import * as React from "react";
import {connect} from "react-redux";
import "./styles.scss";
import {renderTextField} from "userform/utils";
import {getIdToken} from "service.tsx";
import {getBankStatementMonths, getMonths, makeApiCall} from "./utils";
import {Link} from "react-router-dom";
import Loading from "components/loading";
import {closeActivityInAndroid} from "utils/android";
import {logCustomEvent as logCustomPixelEvent} from "../analytics/facebookAnalytics";
import {RouteComponentProps} from "react-router-dom";
import {logQuoraPixelEvent} from "analytics/quoraAnalytics";
import {logBranchEvent} from "analytics/branch";
import {imageBaseUrl} from "config";
import Flashcard from "myshubhlife-component/Flashcard";
import {MessageType} from "utils/variables";
import {getErrorMessages} from "BsPdfUploadV2/utils";

interface IConnectProps {
    userId: number;
    partnerName: string;
    fromDate: number;
    toDate: number;
    user: string;
    location: any;
    dispatch?: (action: any) => void;
    isAndroid: boolean;
}
interface IInstitute {
    addressAvailable: boolean;
    form26AsAvailable: boolean;
    id: string;
    institutionType: string;
    itrVAvailable: boolean;
    name: string;
    originalStatementAvailable: boolean;
}
interface IFiles {
    successfullyUploaded: boolean;
    fileName: string;
}
interface IState {
    startTx: boolean;
    files: IFiles[];
    minimumOneFileUploaded: boolean;
    currentFile: any;
    perfiosTransactionId: string;
    institutionId: string;
    entityId: string;
    linkId: string;
    txId: string;
    completeTxMsg: string;
    fileError: string;
    currentFileName: string;
    institutions: IInstitute[];
    fbToken: string;
    password: string;
    majorBankSelectedCss: boolean[];
    pathname: string;
    active: boolean;
    bsmonths: number;
    userId: number;
    yearMonthFrom: string;
    yearMonthTo: string;
    forwardFlag: string;
    getStarted: boolean;
    error: boolean;
}
class BsPdfUpload extends React.Component<IConnectProps & RouteComponentProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            institutions: [],
            institutionId: "-1",
            entityId: null,
            linkId: null,
            fbToken: null,
            startTx: false,
            files: [],
            minimumOneFileUploaded: false,
            currentFile: null,
            currentFileName: "Choose File",
            perfiosTransactionId: "",
            txId: null,
            completeTxMsg: null,
            fileError: null,
            password: null,
            active: false,
            majorBankSelectedCss: [false, false, false, false],
            pathname: this.props.partnerName &&
            this.props.partnerName !== "sl" ? `/${this.props.partnerName}` : "/",
            bsmonths: 3,
            userId: this.props.userId,
            yearMonthFrom: null,
            yearMonthTo: null,
            forwardFlag: null,
            getStarted: false,
            error: false,
        };
        this.handleInstitutionChange = this.handleInstitutionChange.bind(this);
        this.handleStartTx = this.handleStartTx.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.completeTx = this.completeTx.bind(this);
        this.getPdfPassword = this.getPdfPassword.bind(this);
        this.getMajorBanks = this.getMajorBanks.bind(this);
        this.getBankIdFromMajorBanks = this.getBankIdFromMajorBanks.bind(this);
        this.renderPasswordField = this.renderPasswordField.bind(this);
    }
    public componentWillMount(): void {
        if (this.props.location.query.invoker != null) {
            if (this.props.location.query.invoker === "incompleteInfo") {
                this.setState({
                    forwardFlag: "/inCompleteInfo",
                });
            } else {
                this.setState({
                    forwardFlag: "/",
                });
            }
            this.props.history.push({pathname: this.props.location.pathname , query: {}});
        }

        if ( this.props.user) {
            this.setState({
                userId: parseInt(this.props.user, 10),
            });
        }
    }

    public componentDidMount() {
        this.setState({active: true});
        const getInstitutions = makeApiCall("institutions", {handler: "institutions"});
        getInstitutions.then((response) => {
            const {institutions} = response;
            this.setState({
                institutions,
                fbToken: getIdToken(),
            });   
        }).catch(() => {
            this.setState({error: true});
        }).finally(() => this.setState({active: false}));
    }
    public handleInstitutionChange(e) {
        const resetMajorBankSelecedCss = [false, false, false, false];
        this.setState({
            institutionId: e.target.value,
            majorBankSelectedCss: resetMajorBankSelecedCss,
        });
    }
    public handleStartTx() {
        const userId = this.state.userId;
        const fbToken = getIdToken();
        const institutionId = this.state.institutionId;
        const fromDate = this.props.fromDate;
        const toDate = this.props.toDate;
        const version = "1.1";
        if (institutionId !== "-1") {
            const startTx = makeApiCall("start", {handler: "start", userId, fbToken, institutionId,
                fromDate, toDate, version});
            this.setState({active: true});
            startTx.then((response) => {
                const {perfiosTransactionId, txnId, yearMonthFrom, yearMonthTo, entityId, linkId} = response;
                this.setState({perfiosTransactionId, entityId, linkId, txId: txnId, getStarted: true,
                    startTx : true, active: false, yearMonthFrom, yearMonthTo,
                    bsmonths: (yearMonthFrom && yearMonthTo) ? getBankStatementMonths(yearMonthFrom, yearMonthTo) : null})

            }).catch((err) => this.setState({error: true,fileError : err, active: false}));
        } else {
            alert("Please Select Institution");
        }
    }
    public handleFileChange(e) {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.setState({currentFile : reader.result, currentFileName : file.name.slice(0, 28), fileError: null});
        };
        reader.onerror = (error) => {
            alert ("Could Not Upload File!");
        };
        e.target.value = "";
    }
    public getPdfPassword(fieldName, value) {
        this.setState({
            password: value,
            fileError: null,
        });
    }
    public uploadFile() {
        const {
            perfiosTransactionId, currentFile, currentFileName, password, txId, institutionId, entityId, userId
        } = this.state;
        if (currentFile) {
            const uploadTx = makeApiCall("upload",
                {handler: "upload", file : currentFile, perfiosTransactionId: `${perfiosTransactionId}`,
                    entityId, txId, password, institutionId, userId});
            this.setState({
                active: true,
            });
            uploadTx.then((response) => {
                logBranchEvent("BANK_STATEMENT", {userId: this.props.userId, bsMode: "PDF"});
                const newFileList = [...this.state.files,
                    {successfullyUploaded: true, fileName: this.state.currentFileName}];
                this.setState({
                    currentFile : null,
                    files : newFileList,
                    password: null,
                    currentFileName: "Choose File",
                    fileError: null,
                    active: false,
                    minimumOneFileUploaded: true,
                });
            }, (err) => {
                const newFileList = [...this.state.files,
                    {successfullyUploaded: false, fileName: this.state.currentFileName}];
                this.setState({files: newFileList, fileError : err, active: false,
                    currentFile : null, currentFileName: "Choose File"});
            });
        } else {
            alert("Please choose a file!");
        }
    }
    public completeTx() {
        this.setState({fileError: null})
        const {perfiosTransactionId, entityId, institutionId, userId} = this.state;
        const completeTx = makeApiCall("complete",
            {handler: "complete", perfiosTransactionId: `${perfiosTransactionId}`, entityId, institutionId, userId});
        this.setState({active: true });
        logCustomPixelEvent("Subscribe", this.props.userId);
        logQuoraPixelEvent("AddToCart", this.props.userId);
        completeTx.then(() => {
            this.setState({
                startTx : false,
                completeTxMsg : "File upload completed",
                files: [],
                active: false,
                institutionId: "-1",
                majorBankSelectedCss: [false, false, false, false],
            }, () => {
                    if (!this.props.user && this.state.completeTxMsg) {
                        // TODO:Will have to stop flag calculation then will use below method.
                        // this.goBackToPrevious();
                        if (this.props.isAndroid) {
                            return closeActivityInAndroid("SUCCESS");
                        }
                    }
                });
        }, (err) => {
            this.setState({fileError: getErrorMessages(err), active: false});
            if (this.props.isAndroid) {
                return closeActivityInAndroid("FAILURE");
            }
        });
    }
    public renderPasswordField() {
        return renderTextField(
            "text",
            "Enter Password If Any",
            this.state.password,
            "bs-pdf-pw",
            this.getPdfPassword,
            "",
            "",
            "50",
            "",
            false,
            "PDF password",
            true,
            false,
            false,
            true,
            "",
            "",
            "",
            "",
            "",
            "bs-pdf-password",
        );
    }
    public getBankIdFromMajorBanks(id, index) {
        const resetMajorBankSelecedCss = [false, false, false, false];
        resetMajorBankSelecedCss[index] = true;
        this.setState({
            institutionId: id,
            majorBankSelectedCss: resetMajorBankSelecedCss,
        });
    }
    public getMajorBanks(): any {
        return (
            this.state.majorBankSelectedCss.map((bank, index) => {
                const majorBankImg = ["axis-bank", "hdfc-bank", "icici-bank", "statebank"];
                const bankIds = ["2", "20", "22", "35"];
                return (
                    <div style={{display: "inline-block", marginRight: 5}}
                         key={index}
                         className={`${this.state.majorBankSelectedCss[index] ?
                        "bank-img-selected" : ""}`}>
                    <img
                        src={`${imageBaseUrl}/img/logo/${majorBankImg[index]}-logo.png`}
                        className={`bank-img`}
                        alt="Bank Name"
                        onClick={() => this.getBankIdFromMajorBanks(bankIds[index], index)}
                    />
                    <span
                        style={{
                            display: `${this.state.majorBankSelectedCss[index] ? "inline" : "none"}`}}
                        className="fa fa-check-circle bank-selected-tick">
                    </span>
                    </div>
                );
            })
        );
    }
    public returnBackButton() {
        return (
            <div style={{marginTop: "20px"}}>
                <Link className="go-back-link" to={this.state.pathname}>
                    <div id={"go-back-bs-flow"}
                         className="go-back-incomplete">
                        <i className="fa fa-angle-left arrow-back-application"></i>
                        Go back to application
                    </div>
                </Link>
            </div>
        );
    }
    public goBackToPrevious() {
        const pathname = this.props.partnerName && this.props.partnerName !== "sl" ?
            `/${this.props.partnerName}` + this.state.forwardFlag :
            this.state.forwardFlag;
        this.props.history.push({pathname , query: {invoker: "bs-upload"}});
        return null;
    }

    public render() {
        return (
            <div className={`container-fluid bs-pdf-upload-form`}>
                {!this.props.isAndroid && <div>
                    {!this.props.user && this.returnBackButton()}
                </div>}
                <br></br>
                <div className="row">
                    <div className="col-sm-12">
                        <Loading active={this.state.active}/>
                        
                        {this.state.error ? <Flashcard
                            description="Looks like something is missing"
                            heading="Something's Wrong"
                            supportEmail={true}
                            supportText="Please contact support"
                            messageType={MessageType.ERROR}/> :
                        <>
                            <div className="bs-heading" style={{marginBottom: `${this.state.getStarted ? "15px" : "80px"}`}}>
                                <b>Bank Statement PDF upload</b>
                            </div>
                            <form className="form">
                                <div className="form-group">
                                    <label>Select Your Bank</label>
                                    <div className="major-banks"
                                        style={{display: `${this.state.getStarted ? "none" : "block"}`}}>
                                        {this.getMajorBanks()}
                                    </div>
                                    <select
                                        className="form-control bank-select-box"
                                        id="selectOtherBank"
                                        value={this.state.institutionId}
                                        onChange={this.handleInstitutionChange}
                                        name="institutionId"
                                        disabled={this.state.getStarted}
                                    >
                                        <option value={"-1"}>Other Banks</option>
                                        {this.state.institutions.map((institute, index) => {
                                            return <option key={index} value={institute.id}>{institute.name}</option>;
                                        })
                                        }
                                    </select>
                                </div>
                            </form>
                            <section className="section-bspdfupload"
                                    style={{display: `${this.state.getStarted ? "none" : "block"}`}}>
                                <button
                                    className="btn bs-btn"
                                    onClick={this.handleStartTx}
                                >Get Started
                                </button>
                            </section>
                            <section className="section-bspdfupload-bottom"
                                 style={{display: `${this.state.startTx ? "block" : "none"}`}}>
                            <hr/>
                            <span
                                style={{fontSize: 14}}
                            >Please upload PDF of your last {this.state.bsmonths} months Bank Statement starting from
                                <b> {getMonths(this.state.bsmonths)[0]} </b>
                            </span>
                            <br/>
                            <div className="upload-msg">
                                {
                                    this.state.files.length
                                        ? this.state.files.map((fileUploadInformation, index) => {
                                            return (
                                                <div key={index} className="upload-bs-status">
                                                    <img src={`${imageBaseUrl}/img/pdf.svg`}
                                                         alt="pdf-icon" className="bs-pdf-icon"/>
                                                    <span className="bs-fileName-size">
                                                        {fileUploadInformation.fileName}</span>
                                                    <span style={{marginLeft: 10}}>
                                                        <i
                                                            className={fileUploadInformation.successfullyUploaded ?
                                                                "fa fa-check-circle" : "fa fa-remove"}
                                                            style={{
                                                                color: `${fileUploadInformation.successfullyUploaded ?
                                                                    "green" : "red"}`,
                                                            }}
                                                        ></i>
                                                    </span>
                                                    <div>
                                                        {fileUploadInformation.successfullyUploaded ?
                                                            " Successfully uploaded!" : " Upload failed!"}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    : ""
                                }
                            </div>
                            <div>
                                {
                                    this.state.fileError ?
                                        <span className="file-error-message">{this.state.fileError}</span>
                                        : ""
                                }
                            </div>
                            <div className="row upload-section">
                                <div className="col-sm-12 text-center">
                                    <label htmlFor="pdf-file-upload" className="pdf-file-upload-label">
                                        {this.state.currentFileName}
                                    </label>
                                    <input className="input-bspdfupload"
                                           id="pdf-file-upload"
                                           type="file"
                                           onChange={this.handleFileChange}/>
                                    <br/>
                                    <div>
                                        {this.renderPasswordField()}
                                    </div>
                                    <div>
                                        <button
                                            className="btn bs-btn-upload"
                                            onClick={this.uploadFile}
                                            disabled={!this.state.startTx}
                                        >Upload
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br/>
                        </section>
                        <section className="section-bspdfupload-complete"
                                 style={{display: `${this.state.startTx ? "block" : "none"}`}}>
                            <button
                                className="btn bs-btn-complete"
                                onClick={this.completeTx}
                                disabled={!this.state.minimumOneFileUploaded}
                            >Complete
                            </button>
                        </section>
                        {
                            <span><b>{this.state.completeTxMsg ? this.props.user ? "Please close the window !!"
                                : "Go back to application and check !!" : null}</b></span>
                        }
                        <div className="guide-lines"
                             style={{display: `${this.state.startTx ? "block" : "none"}`}}>
                            <b>Guide Lines:</b>
                            <ol>
                                <li>Please upload bank statement in pdf format of last {this.state.bsmonths} months.
                                </li>
                                <li>Provide password for the pdf if any.</li>
                            </ol>
                        </div>
                        </>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    const authExt =  state.login.authExt;

    return {
        userId: auth.userId,
        partnerName: state.userform.param,
        fromDate: authExt !== null ?
            (authExt.fromDate !== undefined ? parseInt(authExt.fromDate, 10) : null) : null,
        toDate: authExt !== null ?
            (authExt.toDate !== undefined ? parseInt(authExt.toDate, 10) : null ) : null,
        user: authExt !== null ?
            (authExt.userId !== undefined ? authExt.userId : null) : null,
        location: state.router.location,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(BsPdfUpload);
